import React from "react"

export default ({ children }) => (
  <div className="pb-2 mt-4 mb-2 border-bottom">
    <h2>{children}</h2>
  </div>
)
